import type { ActiveAttribute } from '@rover/rsdk/src/apiClient/latest/model/activeAttribute';
import type { Attribute } from '@rover/rsdk/src/apiClient/latest/model/attribute';
import type { ValueAttribute } from '@rover/rsdk/src/apiClient/latest/model/valueAttribute';
import useBrandSpecificPets from '@rover/shared/js/hooks/useBrandSpecificPets';
import { PetType } from '@rover/types/src/Pet';

export type Attributes = ActiveAttribute[] | Attribute[] | ValueAttribute[];

export const useFilteredAttributesByPetTypes = (): {
  filterAttributesByPetTypes: (attributes: Attributes | null | undefined) => Attributes;
} => {
  const availablePetTypes = useBrandSpecificPets();

  const filterAttributesByPetTypes = (attributes: Attributes | null | undefined): Attributes => {
    if (!attributes) {
      return [];
    }

    return attributes.filter((attr) => {
      // If no applicablePetTypes, it's a generic attribute - always include
      if (!attr.applicablePetTypes || attr.applicablePetTypes.length === 0) {
        return true;
      }
      // Check if at least one applicable pet type is in availablePetTypes
      return attr.applicablePetTypes.some((petType) =>
        availablePetTypes.includes(petType as PetType)
      );
    });
  };

  return { filterAttributesByPetTypes };
};
